// Mercado (Pokédollar): itens para o "item pool". Cartas são compradas no
// Deck e shinies na Coleção; aqui ficam os itens que podem cair na partida.
import { api, errorMessage } from "../api";
import { itemDesc, itemIcon, itemName } from "../data";
import { num, t, type MsgKey } from "../i18n";
import type { View } from "../router";
import { loadSession } from "../session";
import { esc, screen } from "../ui";

/** Símbolo do Pokédollar. */
export const PDX = `<span class="pdx-sign" aria-label="Pokédollar">₽</span>`;

type Kind = "special" | "item" | "component";
interface ShopItem { id: string; kind: Kind; price: number; owned: boolean }

export const marketView: View = (root, { query }) => {
  let tab: Kind = (query.get("aba") as Kind) || "special";
  let items: ShopItem[] = [];
  let balance = 0;
  root.innerHTML = screen(t("market.title"), "/menu", `<div class="bw-textbox">${t("common.loading")}</div>`);
  const body = root.querySelector<HTMLElement>(".screen__body")!;

  const show = (msg: string, kind = "error") => {
    const a = body.querySelector<HTMLElement>("[data-alert]");
    if (!a) return;
    a.className = `bw-alert bw-alert--${kind}`;
    a.textContent = msg;
    a.hidden = false;
  };

  function render() {
    const list = items.filter((i) => i.kind === tab);
    const owned = items.filter((i) => i.owned).length;
    body.innerHTML = `
      <div class="shop-head bw-panel">
        <span class="pdx big">${PDX} <b>${num(balance)}</b></span>
        <div class="bw-tabs" role="tablist">${(["special", "item", "component"] as Kind[])
          .map((k) => `<button class="bw-btn ${tab === k ? "bw-btn--blue" : ""}" role="tab" aria-selected="${tab === k}" data-tab="${k}">${t(`market.tab.${k}` as MsgKey)}</button>`)
          .join("")}</div>
      </div>
      <div class="bw-textbox">${t("market.explain")} <b>${t("market.inPool", { n: owned })}</b></div>
      <div data-alert hidden></div>
      <div class="market-grid">${list
        .map((i) => `
        <article class="bw-panel market-item ${i.owned ? "on" : ""}" data-tip="item:${i.id}">
          <img src="${itemIcon(i.id)}" alt="" width="48" height="48">
          <b>${esc(itemName(i.id))}</b>
          <p class="bw-dim small">${esc(itemDesc(i.id))}</p>
          ${i.owned
            ? `<span class="bw-btn" aria-disabled="true">✔ ${t("market.owned")}</span>`
            : `<button class="bw-btn bw-btn--green" data-buy="${i.id}" ${balance < i.price ? 'aria-disabled="true"' : ""}>${PDX} ${num(i.price)}</button>`}
        </article>`)
        .join("")}</div>`;
  }

  body.addEventListener("click", async (e) => {
    const el = (e.target as HTMLElement).closest<HTMLElement>("[data-tab],[data-buy]");
    if (!el) return;
    if (el.dataset.tab) {
      tab = el.dataset.tab as Kind;
      render();
      return;
    }
    const item = items.find((x) => x.id === el.dataset.buy)!;
    if (balance < item.price) return show(t("pdx.notEnough"));
    if (!el.dataset.confirm) {
      el.dataset.confirm = "1";
      el.innerHTML = t("pdx.confirm", { price: `${PDX} ${num(item.price)}` });
      setTimeout(() => el.isConnected && render(), 3000);
      return;
    }
    try {
      balance = (await api.buyItem(item.id)).pokedollars;
      item.owned = true;
      render();
      show(t("market.bought", { name: itemName(item.id) }), "ok");
      void loadSession();
    } catch (err) {
      render();
      show(errorMessage(err));
    }
  });

  api
    .items()
    .then((r) => {
      items = r.items;
      balance = r.pokedollars;
      render();
    })
    .catch((err) => (body.innerHTML = `<div class="bw-alert bw-alert--error">${esc(errorMessage(err))}</div>`));
};
